<template>
  <div>
    <article
      class="category__summary"
      v-for="(post, i) in items"
      :key="i"
    >
      <a :href="post.url" target="_parent">
        <h2>{{ post.title }}</h2>
      </a>
      <p style="font-weight: unset;">{{ post.excerpt }}</p>
      <a :href="post.url" class="link-more" target="_parent">
        {{ $t('readMore') }}
      </a>
    </article>
  </div>
</template>
<script>
export default {
  name: 'CMS-Post',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
}
</script>